import React, { ChangeEvent, useState } from 'react';
import CtaButton from '../CtaButton/CtaButton';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Box, IconButton, Typography } from '@mui/material';

interface ImageInputProps {
  onChange: (file: File | null) => void;
  imageUrl: string | null;
  disabledUpload?: boolean;
  errorMessage?: string | null;
}
const ImageInput = ({
  onChange,
  imageUrl,
  disabledUpload = false,
  errorMessage = null,
}: ImageInputProps) => {
  // Create a reference to the hidden file input element
  const hiddenFileInput = React.useRef<HTMLInputElement | null>(null);

  const [imgData, setImgData] = useState<string | ArrayBuffer | null>(imageUrl);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = () => {
    hiddenFileInput.current?.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.target.files?.[0];
    if (fileUploaded) {
      onChange(fileUploaded);
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(fileUploaded);
    }
    //props.handleFile(fileUploaded);
  };

  const deleteAvatar = () => {
    onChange(null);
    setImgData(null);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Box
        sx={{
          width: '120px',
          height: '120px',
          bgcolor: '#F5F5F5',
          overflow: 'hidden',
          borderRadius: '50%',
          position: 'relative',
        }}
      >
        {!!imgData && !disabledUpload && (
          <IconButton
            onClick={deleteAvatar}
            sx={{
              position: 'absolute',
              bgcolor: 'rgba(134,134,134,0.7)',
              color: 'white',
              width: 30,
              height: 30,
              bottom: 15,
              right: 15,
              '&:hover': {
                bgcolor: 'black',
                color: 'white',
              },
              zIndex: 99,
              border: '1px solid white',
              borderRadius: '50%',
            }}
          >
            <DeleteOutlineOutlinedIcon fontSize="small" />
          </IconButton>
        )}
        <Box
          component="img"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '50%',
          }}
          src={imgData && typeof imgData === 'string' ? imgData : ''}
        />
      </Box>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        accept=".png, .jpg, .jpeg"
        style={{ display: 'none' }}
        disabled={disabledUpload}
      />

      <Box
        display="flex"
        justifyContent="center"
        sx={{
          width: {
            xs: '100px',
            sm: '100px',
            md: '120px',
            lg: '150px',
          },
        }}
      >
        <CtaButton
          variant="text"
          onClick={handleClick}
          sx={{ textDecoration: 'underline' }}
          disabled={disabledUpload}
        >
          Edit
        </CtaButton>
      </Box>
      <Typography sx={{ color: '#f44336' }}>{errorMessage}</Typography>
    </Box>
  );
};

export default ImageInput;
